import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, min-content);
  gap: 3px;
  align-items: center;
`;

export const PriceLabel = styled.span<{ $size: 'small' | 'base' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-size: ${(p) =>
    p.$size === 'large'
      ? fonts.size.xl
      : p.$size === 'medium'
      ? fonts.size.lg
      : p.$size === 'base'
      ? fonts.size.base
      : fonts.size.sm};
  color: ${colors.fontSecondary};
`;

export const PriceAmount = styled.span<{
  $size: 'small' | 'base' | 'medium' | 'large';
  $weight?: 'normal' | 'medium' | 'bold';
}>`
  font-family: ${fonts.body};
  font-weight: ${(p) =>
    p.$weight === 'medium'
      ? fonts.weight.medium
      : p.$weight === 'normal'
      ? fonts.weight.normal
      : fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) =>
    p.$size === 'large'
      ? fonts.size.xl
      : p.$size === 'medium'
      ? fonts.size.lg
      : p.$size === 'base'
      ? fonts.size.base
      : fonts.size.sm};
`;

export const DiscountRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
`;

export const OriginalPrice = styled.span<{ $size: 'small' | 'base' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.normal};
  color: ${colors.grey};
  text-decoration: line-through;
  font-size: ${(p) =>
    p.$size === 'large'
      ? fonts.size.xl
      : p.$size === 'medium'
      ? fonts.size.lg
      : p.$size === 'base'
      ? fonts.size.base
      : fonts.size.sm};
`;

export const DiscountedPrice = styled.span<{ $size: 'small' | 'base' | 'medium' | 'large' }>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) =>
    p.$size === 'large'
      ? fonts.size.xl
      : p.$size === 'medium'
      ? fonts.size.lg
      : p.$size === 'base'
      ? fonts.size.base
      : fonts.size.sm};
`;
